import { Fragment, type JSX, type ReactNode } from "react";

export const Render = (props: { when: boolean; children: ReactNode }) => {
  return props.when ? <>{props.children}</> : null;
};

export function Exists<T>(props: {
  data: T | null;
  then: (data: T & {}) => JSX.Element;
}) {
  if (props.data === null) return null;
  return props.then(props.data as T & {});
}

type AllRequired<T extends any[]> = T extends [infer First, ...infer Rest]
  ? [First & {}, ...AllRequired<Rest>]
  : T;

export function WhenAll<const T extends any[]>(props: {
  deps: T;
  areTruthy: (...args: AllRequired<T>) => JSX.Element;
  otherwise?: (...args: T) => JSX.Element;
}) {
  if (props.deps.map((item) => !!item).includes(false)) {
    return props.otherwise ? props.otherwise(...props.deps) : null;
  }
  return props.areTruthy(...(props.deps as unknown as AllRequired<T>));
}

export function List<T>(props: {
  data: T[];
  extractKey: keyof T | ((data: T) => string);
  render: (item: T, index: number) => ReactNode;
}) {
  return (
    <>
      {props.data.map((item, index) => (
        <Fragment
          key={
            typeof props.extractKey === "function"
              ? props.extractKey(item)
              : String(item[props.extractKey])
          }
        >
          {props.render(item, index)}
        </Fragment>
      ))}
    </>
  );
}
